function Header() {
    return <nav className="green darken-1">
        <div className="nav-wrapper">
        <a href="#" className = "brand-logo" > React Movies </a>
        <ul id="nav-mobile" className="right hide-on-med-and-down">
            <li><a href="https://github.com/Tay811/React_movies_API">Repo</a></li>
        </ul>
        </div>
    </nav>
}

export {Header}